export enum ScrollEvent {
    SCROLL_TO = 'scrolling:scrollTo',
}
